import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export default function NotFound() {
  const { tr } = useLang();
  return (
    <div
      data-testid="page-not-found"
      className="bg-white text-[#0a0a0a] min-h-screen flex items-center pt-32 pb-24"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="font-mono text-[10px] tracking-[0.3em] text-[#FF4D00] mb-8">
          {tr({ it: "— ERRORE 404", en: "— ERROR 404" })}
        </div>
        <h1 className="font-display text-[clamp(4rem,14vw,14rem)] leading-[0.86] tracking-tighter">
          404
        </h1>
        <p className="font-editorial italic text-2xl md:text-3xl text-[#3f3f46] mt-8 max-w-xl">
          {tr({
            it: "La pagina che cerchi non esiste o è stata spostata.",
            en: "The page you are looking for does not exist or has been moved.",
          })}
        </p>
        <Link to="/" data-testid="notfound-home-link" className="btn-primary mt-12 inline-flex">
          {tr({ it: "Torna alla home", en: "Back to home" })} →
        </Link>
      </div>
    </div>
  );
}
